import { useSelectContext } from '../../../../context';
import { Wrapper } from './indicators.styled';
import { Icons } from '../../../../../../../assets';
import { SVG } from '../../../../../../svg';

export const Indicators = () => {
  const { state, actions } = useSelectContext();

  const handleRemoveAll = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    actions.removeAll();
  };

  const handleToggleDropdown = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    actions.toggleDropdown();
  };

  return (
    <Wrapper className={'select-indicators'}>
      {!!state.selectedOptions.length &&
      !state.fullDisabled &&
      state.clearable ? (
        <SVG src={Icons.Cross} action={handleRemoveAll} />
      ) : (
        <SVG
          src={Icons.Chevron}
          action={handleToggleDropdown}
          props={{
            isMirror: state.isOpen,
          }}
        />
      )}
    </Wrapper>
  );
};
